import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import aboutHero from "../../assets/sigiriya-hero.jpg";
import img2 from "../../assets/Sigiriya.jpg";

function Sigiriya() {

    useEffect(() => {
        AOS.init({ duration: 900, once: true });
    }, []);

    return (
        <div className="w-full overflow-hidden">

            {/* ================= HERO SECTION ================= */}
            <section className="relative h-[40vh] w-full">
                <img
                    src={aboutHero}
                    alt="Sigiriya Rock Fortress"
                    className="absolute inset-0 w-full h-full object-fixed"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="relative z-10 flex h-full flex-col items-center justify-center text-center text-white px-4">
                    <h1 data-aos="fade-up" className="text-4xl border border-[#c97b3a] bg-black/40 backdrop-blur-sm p-6 sm:p-5 sm:text-3xl md:text-4xl font-bold mb-3">
                        Sigiriya Rock Fortress
                    </h1>
                </div>
            </section>

            {/* ================= ABOUT SECTION ================= */}
            <section className="relative w-full py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4">

                    {/* Image */}
                    <div
                        data-aos="zoom-in"
                        className="w-full overflow-hidden rounded-xl shadow-lg"
                    >
                        <img
                            src={img2}
                            alt="Sigiriya Rock"
                            className="w-full h-[500px] object-fixed"
                        />
                    </div>

                    {/* Content Card */}
                    <div
                        data-aos="fade-up"
                        className="relative -mt-24 mx-auto max-w-4xl bg-white border border-[#c97b3a] p-8 md:p-12 shadow-xl"
                    >
                        <h2 className="text-3xl font-bold text-center mb-6">
                            Sigiriya Rock Fortress
                        </h2>

                        <p className="text-gray-700 leading-relaxed text-justify mb-4">
                            Sigiriya, also known as the Lion Rock, is one of Sri Lanka’s most iconic
                            historical landmarks located in the Central Province near Habarana. Built
                            in the 5th century by King Kashyapa, this ancient rock fortress rises
                            nearly 200 meters above the surrounding jungle.
                        </p>

                        <p className="text-gray-700 leading-relaxed text-justify mb-4">
                            The site is famous for its impressive frescoes, the Mirror Wall, and the
                            massive Lion Gate that leads to the summit. At the top of the rock, visitors
                            can explore the ruins of the royal palace and enjoy breathtaking panoramic
                            views of the surrounding forests and villages.
                        </p>

                        <p className="text-gray-700 leading-relaxed text-justify">
                            Today, Sigiriya is a UNESCO World Heritage Site and one of the most
                            visited attractions in Sri Lanka. It offers a fascinating combination
                            of ancient history, remarkable engineering, and stunning natural beauty.
                        </p>

                    </div>
                </div>
            </section>

            {/* ================= WHATSAPP FLOAT BUTTON ================= */}
            <a
                href="https://wa.me/94764806045?text=I%20saw%20your%20website.%20Can%20you%20give%20me%20information%20regarding%20your%20villa."
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-5 right-5 z-50"
            >
                <img
                    src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
                    alt="WhatsApp"
                    className="h-12 w-12 sm:h-14 sm:w-14 rounded-full shadow-lg transition hover:scale-110"
                />
            </a>

        </div>
    );
}

export default Sigiriya;